var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.ticketCreated)?_c('div',[_vm._v("\n        working, please wait...\n    ")]):_c('div',[_vm._v("\n        Please close this window\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }